import styled from "styled-components"
import { TextDiv, TextInput } from "../../common/Text"
import { useFormContext } from "react-hook-form"
import { StyledButton } from "../../common/Buttons"
import { useAuthDuplicate } from "../../../hooks/useAuth"
import { toast } from "react-toastify"

const EmailInputBox = () => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext()

  const email = watch("email")
  const isEmailValid = watch("isEmailValid")
  const { refetch } = useAuthDuplicate({ email: email })
  const checkEmailDuplicate = () => {
    refetch().then((res) => {
      if (res.data.result === "valid") {
        setValue("isEmailValid", true)
        toast.success("사용가능한 ID입니다.", {
          position: "top-right",
          theme: "light",
        })
      } else {
        toast.error("사용할 수 없는 ID입니다.", { position: "top-right" })
      }
    })
  }

  return (
    <RelativeDiv>
      <EmailInputContainer>
        <TextInput
          type="email"
          $isError={errors.email ? true : false}
          placeholder="ID(이메일형식)"
          disabled={isEmailValid}
          {...register("email")}
        />
        <StyledButton
          $size="large"
          $bgColor={isEmailValid ? "var(--custom-blue)" : ""}
          $textColor={isEmailValid ? "var(--custom-white-smoke)" : ""}
          disabled={isEmailValid}
          onClick={checkEmailDuplicate}
          style={{ fontSize: 16 }}
        >
          {isEmailValid ? "확인 완료" : "중복 확인"}
        </StyledButton>
      </EmailInputContainer>
      {errors.email && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: 40,
          }}
        >
          * {errors.email.message?.toString()}
        </TextDiv>
      )}
    </RelativeDiv>
  )
}

export default EmailInputBox

const RelativeDiv = styled.div`
  position: relative;
`

const EmailInputContainer = styled.div`
  display: flex;
  gap: 15px;

  :last-child {
    width: 160px;
  }
`
